<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red2 page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1 class="text-white">34th Bakery Carnival </h1>
                        <div class="contacts-title">
                            <h5 class="display-28"> <i class="fa fa-calendar"></i> Date </h5>
                            <h6 class="">Sunday, 14 December, 2025</h6>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>

<!-- CONTACT FORM
        ================================================== -->
<section class="bg-light-yellow pb-5 pt-5">
    <div class="container">
        <div class="row justify-content-center">



            <div class="col-lg-5">

                <div class="contact-form">
                    <h2>Contest Participation Form</h2>

                    <form ng-app="ContestApp" ng-controller="ContestFormController" ng-submit="submitContestForm()"
                        action="#" method="post" id="contestForm">

                        <div class="input-group">
                            <i class="fa fa-user"></i>
                            <input type="text" placeholder="Your Name *">
                        </div>

                        <div class="input-group">
                            <i class="fa fa-envelope"></i>
                            <input type="email" placeholder="Email *">
                        </div>

                        <div class="input-group">
                            <i class="fa fa-phone"></i>
                            <input type="text" placeholder="Phone *">
                        </div>

                        <div class="input-group">
                            <i class="fa fa-location-dot"></i>
                            <input type="text" placeholder="Location *">
                        </div>

                        <div class="textarea-group">
                            <i class="fa fa-comment-dots"></i>
                            <textarea placeholder="Any specific requirements?" rows="4"></textarea>
                        </div>
                        <p id="formError" style="color:red; margin:5px 0;"></p>

                        <button type="submit" class="submit-btn">Submit</button>
                    </form>
                </div>

            </div>

            <!-- <div class="col-lg-5 carnival">
                <div class="contact-details">
                    <div class="row">
                        <div class="section-title-04 mb-6 position-relative">
                            <h2 class="title-main2 display-16 lh-1 mb-0 text-white">
                                Events details </h2>
                            <div class="line black"></div>
                        </div>
                        <div class="col-lg-12">
                            <div class="contact-info">
                                <div class="contacts-icon">
                                    <i class="fa fa-calendar"></i>
                                </div>
                                <div class="contacts-title">
                                    <h5 class="text-white font-weight-600 display-28">Date </h5>
                                    <h6 class="text-white font-weight-500">Sunday, 14 December, 2025</h6>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div> -->

        </div>



    </div>
</section>


<div id="otpModal" style="display:none; position:fixed; inset:0; background:rgba(0,0,0,0.6);
    align-items:center; justify-content:center; z-index:999999;">

    <div style="background:white; padding:25px; width:90%; max-width:400px; border-radius:10px;
        position:absolute; top:50%; left:50%; transform:translate(-50%, -50%);">

        <!-- CLOSE BUTTON WITH ID -->
        <div id="closeOtpModal" style="position:absolute; top:10px; right:15px; font-size:22px; cursor:pointer;">
            ✕
        </div>

        <h3 class="text-center">Email Verification</h3>
        <p class="text-center">Enter the OTP sent to your email.</p>

        <input id="otpInput" type="text" class="form-control" placeholder="Enter OTP">

        <p id="otpStatus" style="margin-top:8px; color:red;"></p>

        <div class="d-flex justify-content-center">
            <!-- REMOVE ANGULAR CLICK, USE JS ONLY -->
            <button id="verifyOtpBtn" class="btn-main" style="background-color:#ec2b34; color:white; padding:8px 20px;
                    border:none; border-radius:5px;">
                Verify OTP
            </button>
        </div>

    </div>

</div>

<!-- <script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.8.2/angular.min.js"></script> -->